import React from 'react'

const CourseListComponent = ({ course = { image: "", title: "", description: "", level: "", author: "", average: "" } }) => {

    const etoiles = [];

    for (let index = 0; index < parseInt(course.average); index++) {
        etoiles.push(<span className="star"></span>);
    }

    return (
        <div className="course-card course-card-list">
            <div className="course-card-thumbnail">
                <img src={course.image} />
                <a href="course-intro.html" className="play-button-trigger"></a>
            </div>
            <div className="course-card-body">
                <a href="course-intro.html">
                    <h4>{course.title}</h4>
                </a>
                <p>{course.description}</p>
                <div className="course-details-info">
                    <ul>
                        <li> <i className="icon-feather-sliders"></i> {course.levelDisplay} </li>
                        <li> Par <a href="user-profile-1.html">{course.author}</a> </li>
                        <li>
                            <div className="star-rating">
                                <span className="avg"> {course.average} </span>
                                {etoiles}
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
        </div>

    )
}

export default CourseListComponent
